import script from "./Shipment.vue?vue&type=script&setup=true&lang=js"
export * from "./Shipment.vue?vue&type=script&setup=true&lang=js"

import "./Shipment.vue?vue&type=style&index=0&id=1ce5f049&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce5f049"]])

export default __exports__